export function mapProductId(
  productId: string,
  additionalPrefix?: string | RegExp,
) {
  return additionalPrefix ? productId.replace(additionalPrefix, '') : productId;
}
